/**
 * Global keyboard shortcuts parity with plugin/lectura.
 * Keeps Reveal defaults intact while guaranteeing key app actions.
 */

import { isRevealPrintPdfMode } from '../reveal-print-core';

declare global {
  interface Window {
    __lecturaKeyboardShortcutHandler__?: (e: KeyboardEvent) => void;
    __lecturaOpenProfileSettings?: (section?: 'appearance' | 'tts' | 'presentation' | 'shortcuts' | 'account') => void;
    __lecturaToggleResources?: () => void;
    LecturaNext?: {
      toggle?: () => void;
      toggleTTS?: () => void;
    };
  }
}

export function setupKeyboardShortcuts(): void {
  if (typeof window === 'undefined') return;

  if (typeof Reveal !== 'undefined' && typeof Reveal.configure === 'function') {
    Reveal.configure({
      keyboardCondition() {
        if (isRevealPrintPdfMode()) return false;
        return !document.querySelector('.rf-settings-page.rf-settings-page-open');
      }
    });
  }

  const prev = window.__lecturaKeyboardShortcutHandler__;
  if (prev) window.removeEventListener('keydown', prev, true);

  const handler = (e: KeyboardEvent): void => {
    if (!e || e.defaultPrevented) return;
    if (isRevealPrintPdfMode()) return;
    if (document.querySelector('.rf-settings-page.rf-settings-page-open')) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    const target = e.target as HTMLElement | null;
    const tag = target?.tagName?.toLowerCase?.() || '';
    const isEditable = !!(target && (target.isContentEditable || tag === 'input' || tag === 'textarea' || tag === 'select'));
    if (isEditable) return;

    const key = String(e.key || '').toLowerCase();
    if (e.key === '?' || (e.shiftKey && key === '/')) {
      e.preventDefault();
      e.stopPropagation();
      window.__lecturaOpenProfileSettings?.('shortcuts');
      return;
    }
    if (key === 's') {
      e.preventDefault();
      e.stopPropagation();
      const qrBtn = document.querySelector('.lectura-bar-qr-btn') as HTMLButtonElement | null;
      if (qrBtn) qrBtn.click();
      return;
    }
    if (key === 'c') {
      e.preventDefault();
      e.stopPropagation();
      window.LecturaNext?.toggle?.();
      return;
    }
    if (key === 'r') {
      e.preventDefault();
      e.stopPropagation();
      window.__lecturaToggleResources?.();
      return;
    }
    if (key === 't') {
      e.preventDefault();
      e.stopPropagation();
      window.LecturaNext?.toggleTTS?.();
    }
  };

  window.__lecturaKeyboardShortcutHandler__ = handler;
  window.addEventListener('keydown', handler, true);
}

